var map = {
	"./Casino-banner.png": 830,
	"./Fish Games-banner.png": 831,
	"./Lottery-banner.png": 832,
	"./Poker-banner.png": 833,
	"./RNG-banner.png": 834,
	"./Slots-banner.png": 835,
	"./Sports-banner.png": 836,
	"./download-banner.png": 421,
	"./download/download-middle-banner.png": 422,
	"./eSports-banner.png": 837,
	"./help-centre/help-centre-banner.png": 423,
	"./poker/top-banner.png": 838,
	"./pt-lobby-banner.png": 839,
	"./sort-selection-banner.png": 840,
	"./v3/promotion-banner.png": 841,
	"./video-banner.png": 424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 829;